<template>
  <center>
    <div :key="renderKey">
      <div class="card card-body agatrs-card-style">
        <div class="row">
          <div class="col-md-2 offset-md-5 align-center">
            <base-button
              @click="openModal()"
              class="btn-dark float-sm-none float-md-left"
            >
              <span><i class="tim-icons icon-simple-add"></i> New ACSA</span>
            </base-button>
          </div>
        </div>
        <div class="row">
          <el-table :data="acsaAgreements" role="table"
        aria-label="ACSA Agreements Table">
            <el-table-column :min-width="250" align="left" label="Actions">
              <div slot-scope="props">
                <router-link
                  :to="`/Admin/AcsaFiles/${props.row.acsaAgreementId}`"
                  class="btn-link btn-warning"
                >
                  <i class="tim-icons icon-pencil"></i>
                  <span
                    class="hide-if-small-screensize"
                  >
                    Edit ACSA</span
                  >
                </router-link>
                <br>
                <a
                  href="#"
                  @click="
                    showImplementingAgreementsModal(props.row.acsaAgreementId)
                  "
                  class="btn-link btn-primary"
                >
                  <i class="tim-icons icon-notes"></i
                  ><span
                    class="hide-if-small-screensize"
                  >
                    Show IA's</span
                  >
                </a>
                <br>
                <a
                  href="#"
                  @click="openNewIaModal(props.row.acsaAgreementId)"
                  class="btn-link btn-primary"
                >
                  <i class="tim-icons icon-simple-add"></i
                  ><span
                    class="hide-if-small-screensize"
                  >
                    New IA</span
                  >
                </a>
                <br>
                <a
                  href="#"
                  @click="deleteAcsa(props.row.acsaAgreementId, props.row.name)"
                  class="btn-link btn-danger"
                >
                  <i class="tim-icons icon-trash-simple"></i>
                  <span
                    class="hide-if-small-screensize"
                  >
                    Delete</span
                  >
                </a>
              </div>
            </el-table-column>

            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              sortable
              :formatter="column.formatter"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
          </el-table>
        </div>

        <!-- Show Edit IA Modal -->
        <b-modal
          ref="showIaModal"
          scrollable
          hide-footer
          hide-header
          no-close-on-backdrop
          size="lg"
          body-class="custom_alert_body"
        >
          <el-table :data="implementingAgreements" role="table"
        aria-label="Implementing Arrangements Table">
            <el-table-column :min-width="90" align="left" label="Actions">
              <div slot-scope="props">
                <el-tooltip
                  content="Edit this Implementing Agreement."
                  :open-delay="300"
                  effect="light"
                  placement="top"
                >
                  <router-link
                    :to="`/Admin/IaFiles/${props.row.implimentArrangementId}`"
                    class="btn-link btn-primary"
                  >
                    <i class="tim-icons icon-pencil"></i>
                    <span class="hidden-xs-only hide-if-small-screensize"
                      >Edit IA</span
                    >
                  </router-link>
                </el-tooltip>
                <el-tooltip
                  content="Delete"
                  :open-delay="300"
                  effect="light"
                  placement="top"
                >
                  <a
                    href="#"
                    @click="
                      deleteIa(props.row.implimentArrangementId, props.row.name)
                    "
                    class="btn-link btn-danger"
                  >
                    <i class="tim-icons icon-trash-simple"></i>
                    <span class="hidden-xs-only hide-if-small-screensize"
                      >Delete</span
                    >
                  </a>
                </el-tooltip>
              </div>
            </el-table-column>

            <el-table-column
              v-for="column in iaColumns"
              :key="column.label"
              :min-width="column.minWidth"
              sortable
              :formatter="column.formatter"
              :prop="column.prop"
              :label="column.label"
            >
            </el-table-column>
          </el-table>
          <div class="alert_footer align-center">
            <base-button
              type="primary"
              @click="closeImplementingAgreementsModal()"
              class="btn-primary"
              ><i class="tim-icons icon-double-left"></i> Return to
              Table</base-button
            >
          </div>
        </b-modal>

        <!-- Show ACSA Modal -->
        <b-modal
          ref="showAcsaModal"
          scrollable
          hide-footer
          hide-header
          no-close-on-backdrop
          size="lg"
          body-class="custom_alert_body"
        >
          <div class="alert_header align-center">Add New ACSA</div>
          <div class="container">
            <label for="acsaName">ACSA Name</label>
            <base-input
              id="acsaName"
              v-model="selectedName"
              name="Name"
              placeholder="Please type name."
            ></base-input>
            <label for="acsaRemark">ACSA Remark</label>
            <base-input
              id="acsaRemark"
              v-model="selectedRemark"
              name="Remark"
              placeholder="Please type a remark."
            ></base-input>
          </div>

          <div class="alert_footer align-center">
            <base-button
              type="primary"
              @click="closeModal()"
              class="btn-primary"
            >
              <i class="tim-icons icon-double-left"></i> Return to Table
            </base-button>
            <base-button
              @click="saveAcsaAgreement()"
              class="btn float-right"
              type="primary"
            >
              <i class="tim-icons icon-send"></i> Save ACSA
            </base-button>
          </div>
        </b-modal>

        <!-- Show New IA Modal -->
        <b-modal
          ref="showNewIaModal"
          scrollable
          hide-footer
          hide-header
          no-close-on-backdrop
          size="lg"
          body-class="custom_alert_body"
        >
          <div class="alert_header align-center">Add New IA</div>

          <div class="container">
            <label for="acsaId">ACSA ID</label>
            <base-input
              id="acsaId"
              v-model="selectedIaAcsaId"
              disabled
              name="AcsaId"
              placeholder="N/A"
            ></base-input>
            <label for="iaName">IA Name</label>
            <base-input
              id="iaName"
              v-model="selectedIaName"
              name="Name"
              placeholder="Please type name."
            ></base-input>
            <label for="iaRemark">IA Remark</label>
            <base-input
              id="iaRemark"
              v-model="selectedIaRemark"
              name="Remark"
              placeholder="Please type a remark."
            ></base-input>
          </div>

          <div class="alert_footer align-center">
            <base-button
              type="primary"
              @click="closeNewIaModal()"
              class="btn-primary"
            >
              <i class="tim-icons icon-double-left"></i> Back
            </base-button>
            <base-button
              @click="saveNewIa()"
              class="btn float-right"
              type="primary"
            >
              <i class="tim-icons icon-send"></i> Save IA</base-button
            >
          </div>
        </b-modal>
      </div>
    </div>
  </center>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { Table, TableColumn, Select, Option, Button } from "element-ui";
import { BaseSwitch } from "@/components";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { BaseButton, BaseInput } from "@/components";
import { Modal } from "@/components";
import axios from "@/axios";
import swal from "sweetalert2";

export default {
  name: "EditAcsas",
  props: ["AcsaId", "CountryId"],
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BaseSwitch,
    BaseInput,
    BaseButton,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Treeselect,
    Button,
  },
  data() {
    return {
      acsaAgreements: [],
      implementingAgreements: [],
      file: "",
      options: [],
      selectedName: "",
      selectedRemark: "",
      selectedIaName: "",
      selectedIaRemark: "",
      selectedIaAcsaId: "",
      selectedFile: "",
      renderKey: 0,
      tableColumns: [
        {
          prop: "acsaAgreementId",
          label: "ACSA ID",
          minWidth: 150,
          scope: "col"
        },
        {
          prop: "name",
          label: "ACSA Name",
          minWidth: 150,
          scope: "col"
        },
        {
          prop: "remark",
          label: "Remark",
          minWidth: 150,
          scope: "col"
        },
        {
          prop: "updateDateLabel",
          label: "Last Modified",
          minWidth: 150,
          scope: "col"
        },
      ],
      iaColumns: [
        {
          prop: "implimentArrangementId",
          label: "IA ID",
          minWidth: 50,
          scope: "col"
        },
        {
          prop: "name",
          label: "Name",
          minWidth: 50,
          scope: "col"
        },
        {
          prop: "remark",
          label: "Remark",
          minWidth: 50,
          scope: "col"
        },
      ],
    };
  },
  computed: {},
  mounted() {
    this.getPaginatedAcsasByCountry(this.$props.CountryId);
  },
  methods: {
    ...mapActions({
      updateAcsaAgreement: "acsaAgreement/updateAcsaAgreement",
      getAcsaAgreement: "acsaAgreement/getAcsaAgreement",
      saveAcsaFile: "acsaAgreement/saveAcsaFile",
    }),
    getPaginatedAcsasByCountry() {
      this.axios
        .get(
          `api/acsaAgreements/admin/acsas/country/${this.$props.CountryId}/1/999999`
        )
        .then((response) => {
          this.acsaAgreements = response.data.results;
        });
    },
    getImplementingAgreements() {
      this.axios
        .get(`api/implimentarrangements/agreement/${this.selectedIaAcsaId}`)
        .then((response) => {
          this.implementingAgreements = response.data;
          if (this.implementingAgreements == null) {
            this.implementingAgreements = [
              {
                implimentArrangementId: "N/A",
                name: "N/A",
                remark: "N/A",
              },
            ];
          }
        });
    },
    returnToEditAcsaDashboard() {
      this.$router.push("/Admin/Acsas");
    },
    openModal() {
      this.$refs.showAcsaModal.show();
    },
    closeModal() {
      this.$refs.showAcsaModal.hide();
    },
    openNewIaModal(newIaAcsaId) {
      this.selectedIaAcsaId = newIaAcsaId;
      this.$refs.showNewIaModal.show();
    },
    closeNewIaModal() {
      this.$refs.showNewIaModal.hide();
    },
    showImplementingAgreementsModal(clickedAcsaId) {
      this.selectedIaAcsaId = clickedAcsaId;
      this.getImplementingAgreements();
      this.$refs.showIaModal.show();
    },
    closeImplementingAgreementsModal() {
      this.$refs.showIaModal.hide();
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    async deleteAcsa(fileId, fileName) {
      let result = await new swal({
        title: "Delete Confirmation",
        text: `Do you want to delete: "${fileName}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: `Delete ACSA #${fileId}!`,
        reverseButtons: true
      }); 

      if (result.value) {
        try {
          await axios.delete(`api/acsaagreements/delete/${fileId}`);
          new swal({
              title: "Confirmation of Delete",
              text: `"${fileName}" has been deleted successfully.`,
              icon: "success",
              confirmButtonColor: "#10b45a",
            });
            this.getPaginatedAcsasByCountry(this.$props.CountryId);
        } catch (err) {
          this.$toast.error(err.response.data);
        }
      } else {
        this.$toast.error('ACSA not deleted');

      }
    },
     // });
    //},
    deleteIa(fileId, fileName) {
      new swal({
        title: "Delete Confirmation",
        text: `Do you want to delete: "${fileName}"?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#10b45a",
        cancelButtonColor: "red",
        confirmButtonText: `Delete IA #${fileId}!`,
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          axios
            .delete(`api/implimentarrangements/delete/${fileId}`)
            .then((response) => {
              new swal({
                title: "Confirmation of Delete",
                text: `"${fileName}" has been deleted successfully.`,
                icon: "success",
                confirmButtonColor: "#10b45a",
              });
              this.getPaginatedAcsasByCountry(this.$props.CountryId);
              this.getImplementingAgreements(this.selectedIaAcsaId);
            });
        }
      });
    },
    saveAcsaAgreement() {
      let newAcsaAgreement = {
        CountryId: this.$props.CountryId,
        Name: this.selectedName,
        Remark: this.selectedRemark,
      };

      axios.post("api/acsaagreements", newAcsaAgreement).then((response) => {
        this.getPaginatedAcsasByCountry(this.$props.CountryId);
        this.selectedName = "";
        this.selectedRemark = "";
      });

      this.closeModal();
    },
    saveNewIa() {
      let newIa = {
        acsaAgreementId: this.selectedIaAcsaId,
        Name: this.selectedIaName,
        Remark: this.selectedIaRemark,
      };

      axios.post("api/implimentarrangements", newIa).then((response) => {
        this.getPaginatedAcsasByCountry(this.$props.CountryId);
        this.selectedIaName = "";
        this.selectedIaRemark = "";
      });

      this.closeNewIaModal();
    },
    async submit() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          let formData = new FormData();

          formData.append("agreementId", this.$props.AcsaId);
          formData.append("IFile", this.file);

          axios
            .post("/api/acsaagreementfiles/", formData, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then(() => {
              this.getPaginatedAcsasByCountry();
            });
        }
      });
      this.closeFileModal();
    },
  },
};
</script>

<style scoped></style>
